<template lang="pug">
    section
        .tag-row
            el-form-item(prop="tags")
                el-tag(
                    v-for="tag in tags"
                    closable
                    :key="tag.name"
                    size="large"
                    @close="removeTag(tag)"
                ) {{ tag.name }}
                el-autocomplete.input-new-tag(
                    v-if="newTagInputVisible"
                    v-model="newTagInput"
                    ref="newTagInput"
                    size="small"
                    value-key="name"
                    :fetch-suggestions="autocompleteTag"
                    :placeholder="$t('Add tag')"
                    @select="selectExistingTag"
                    @keydown.escape.native="resetNewTag"
                    @keydown.enter.native.prevent="addNewTag"
                    @clear="resetNewTag"
                    @blur="blurNewTag"
                    :maxlength="255"
                    show-word-limit
                )
                el-button.button-new-tag(
                    v-else
                    type="primary"
                    icon="el-icon-fa-plus fas"
                    size="large"
                    @click="showTagInput"
                ) {{ $t('Add tag') }}
        //- .content-status-flex-row
        //-     .content-status-flex-col.datepickers
        //-         el-row(:gutter="20")
        //-             el-col(:span="12")
        //-                 el-form-item.is-full-width(:label="$t('Publish start')" prop="publish_start")
        //-                     el-date-picker.is-full-width(
        //-                         v-model="publishStart"
        //-                         type="date"
        //-                         :format="$t('yyyy-MM-dd')"
        //-                         prefix-icon="far el-icon-fa-calendar-alt"
        //-                         :picker-options="{firstDayOfWeek:1, disabledDate: disabledPublishStartDate}"
        //-                     )
        //-             el-col(:span="12")
        //-                 el-form-item.is-full-width(:label="$t('Publish end')" prop="publish_end")
        //-                     el-date-picker.is-full-width(
        //-                         v-model="publishEnd"
        //-                         type="date"
        //-                         :format="$t('yyyy-MM-dd')"
        //-                         prefix-icon="far el-icon-fa-calendar-alt"
        //-                         :picker-options="{firstDayOfWeek:1, disabledDate: disabledPublishEndDate}"
        //-                     )
        //-     .content-status-flex-col.status-switch
        //-         el-form-item
        //-             el-switch(
        //-                 :active-text="$t('Active')"
        //-                 inactive-color="#ff4949"
        //-                 v-model="status"
        //-             )
        //- // el-form-item(:label="$t('Publish from / to')" prop="publish")
        //-     el-date-picker(
        //-         type="datetimerange"
        //-     )
        //-
        //- el-form-item(:label="$t('Page Type')" prop="view")
        //-     el-select.is-full-width(
        //-         disabled
        //-         placeholder="" v-model="view" valueKey="view"
        //-     )
        //-         el-option(v-for="item in options.view.items" :key="item.value" :label="item.name" :value="item.value")
        //-
        //- el-form-item(:label="$t('Category')" prop="category")
        //-     el-select.is-full-width(
        //-         disabled
        //-         placeholder="" v-model="category" valueKey="key"
        //-         :class="{ 'loading': options.category.loading }"
        //-     )
        //-         el-option(v-for="item in options.category.items" :key="item.id" :label="item.name" :value="item")
</template>

<i18n>
{
  "de": {
    "Tags": "Tags",
    "Add tag": "Tag hinzufügen"
  }
}
</i18n>

<script>

import Fuse from 'fuse.js'
import _ from 'lodash'
import { useSetupStore, useRestrictedAreaMemberStore } from '@/stores'

export default {
    name: 'Tags',
    data() {
        return {
            newTagInputVisible: false,
            newTagInput: '',
            // tags: [
            //     { name: 'inventore' },
            //     { name: 'architecto' },
            // ]
        };
    },
    computed: {
        autocompleteTagOptions() {
            let options = this.options.memberTag.items
            return options.filter(option => {
                return ! this.tags.find(tag => tag.name === option.name)
            })
        },
        tags() {
            return _.get(this.form, 'memberTags') || []
        },
        setupStore() {
            return useSetupStore()
        },
        memberStore() {
            return useRestrictedAreaMemberStore()
        },
        activeCms() {
            return this.setupStore.activeCms
        },
        form() {
            return this.memberStore.form
        },
        options() {
            return this.memberStore.options
        },
    },
    methods: {
        showTagInput() {
            this.newTagInputVisible = true
            this.$nextTick(() => {
                this.$refs.newTagInput.$refs.input.focus()
            })
        },
        addNewTag() {
            this.addTag(this.newTagInput);
            this.resetNewTag();
            this.$nextTick(this.showTagInput);
        },
        resetNewTag() {
            this.newTagInputVisible = false
            this.newTagInput = ''
        },
        blurNewTag() {
            // setTimeout(() => {
            //     if (this.$refs.newTagInput && this.$refs.newTagInput.$refs.input.focused === false) this.resetNewTag();
            // }, 150);

            setTimeout(() => {
                if (this.$refs.newTagInput && this.$refs.newTagInput.$refs.input.focused === false) this.addTag(this.newTagInput);
                this.resetNewTag();
            }, 150);
        },
        autocompleteTag(query, callback) {
            if (! this.autocompleteTagOptions.length || ! query) {
                callback([])
                return false
            }
            const settings = {
                shouldSort: true,
                tokenize: true,
                matchAllTokens: true,
                threshold: 0.3,
                minMatchCharLength: 1,
                keys: ['name'],
            }
            const fuse = new Fuse(this.autocompleteTagOptions, settings)
            const result = _.map(fuse.search(query), el => {
                return el.item
            })
            callback(result)
        },
        selectExistingTag(tag) {
            this.addTag(tag.name);
            this.resetNewTag();
            this.$nextTick(this.showTagInput);
        },
        addTag(name) {
            this.memberStore.addFormMemberTag(name)
        },
        removeTag(tag) {
            this.memberStore.removeFormMemberTag(tag)
        },
    }
}
</script>

<style lang="sass" scoped>
    .tag-row::v-deep .el-form-item__content
        display: flex
        flex-wrap: wrap
        gap: 10px
        &::before
            display: none

    .el-tag + .el-tag
        margin-left: 0

    .el-tag
        vertical-align: middle
        // & + .button-new-tag,
        // & + .input-new-tag
        //   margin-left: 10px

    .button-new-tag
        min-width: 160px
        height: 32px
        line-height: 30px
        padding-top: 0
        padding-bottom: 0
        vertical-align: middle

    .input-new-tag
        width: 220px
        height: 32px
        line-height: 30px
        vertical-align: middle

    .tag-row .el-form-item
        margin-bottom: 0
</style>
